import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { Box, Theme, Typography } from '@mui/material';
import { broadcastChipSettingsByType } from 'modules/broadcasts/constants';
import { BroadcastType } from '@trnsact/trnsact-shared-types';

interface Props {
  type: BroadcastType;
}

export const BroadcastTypeChip = ({ type }: Props) => {
  const chipSettings = broadcastChipSettingsByType[type] ?? {};

  const classes = useStyles({ bgColor: chipSettings.bgColor });

  return (
    <Box className={classes.container}>
      <Typography align="center" component="span" variant="subtitle2" color="textSecondary">
        {chipSettings.label}
      </Typography>
    </Box>
  );
};

const useStyles = makeStyles<Theme, { bgColor: string }>({
  container: {
    display: 'inline-flex',
    borderRadius: '4px',
    padding: '2px 8px',
    backgroundColor: ({ bgColor }) => bgColor,
  },
});
